import FieldTimeSpent from "../../../generic/datetime/time-spent/time-spent"
import FieldConfig from "../../../proto/field-config"
import FieldTimeReportMinutes_TableCell from "./render/table/table-cell"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import FieldTimeReportMinutes_TableCellCalculated from "./render/table/table-cell-calculated"
import FieldEstimate_AggregateCell from "../../../generic/estimate/render/aggregate/aggregate-cell"

export default class FieldTimeReportMinutes extends FieldTimeSpent {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Time report minutes";
        this.label      = "Time reported";
        this.icon       = 'i5-time-reported'
        this.placeholderValueExample    = "Enter time spent e.g. 3h 20m"
        this.hasStartEnd                = true

        this.canBeBillable              = true      // !!!

        this.hasCalculatedValues        = true

        this.presetMinutes = [
            {value:15, label: "15"},
            {value:30, label: "30"},
            {value:45, label: "45"}
        ]

        this.presetHours = [
            {value: 60, label: "1"},
            {value: 120, label: "2"},
            {value: 180, label: "3"},
            {value: 240, label: "4"},
            {value: 300, label: "5"},
            {value: 360, label: "6"},
            {value: 420, label: "7"},
            {value: 480, label: "8"}
        ]

        this.renderComponents.tableCell             = FieldTimeReportMinutes_TableCell
        this.renderComponents.tableCellCalculated   = FieldTimeReportMinutes_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldEstimate_AggregateCell
    }

    /** AGGREGATE **/
    getDefaultAggregateFunction(): AggregateFunctionType {
        return AggregateFunctionType.SUM
    }

    getAggregateOptions(): AggregateFunctionType[] {
        return [
            AggregateFunctionType.SUM,
            AggregateFunctionType.MIN,
            AggregateFunctionType.MAX,
            AggregateFunctionType.MEDIAN,
            AggregateFunctionType.AVERAGE,
        ]
    }
}